import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import DashBoardLayout from "../../Layouts/DashboardLayout/DashBoardLayout";
import "./historytable.css";
import PageLoader from "../../Models/Pageloader/PageLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPoHistoryList,
  fetchPoStatus,
} from "../../Store/Actions/vendor_dashboard";
import HistoryTable from "../../Components/HistoryTable";
import { useParams } from "react-router-dom";

const HistoryTablePage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { loading, error, poHistory } = useSelector(
    (state) => state.VendorDashboardReducer
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchPoHistoryList(id));
    }
  }, [id]);

  return (
    <DashBoardLayout>
      {loading && <PageLoader />}
      <div className="main-dashboard-body mb-3">
        <h3 className="vendor-dashboard-heading py-2 px-3">
          {t("PO History")}
        </h3>

        <div className="container-fluid mt-2 mb-5">
          {error ? (
            <div className="error-message">
              <p>{t("Error loading PO data")}</p>
            </div>
          ) : (
            <HistoryTable poHistory={poHistory}/>
          )}
        </div>
      </div>
    </DashBoardLayout>
  );
};

export default HistoryTablePage;
